
import { createContext, useContext } from 'react';
import { User, LoginPayload, RegisterPayload } from '@/types/auth';

export interface Session {
  accessToken: string;
  refreshToken: string | null;
  expiresAt: number;
}

export interface AuthContextType {
  user: User | null;
  /** Aggiorna direttamente lo stato utente (es. premium ottimistico post-acquisto). */
  setUser: (user: User | null) => void;
  isLoading: boolean;
  error: string | null;
  session: Session | null;
  authInitialized: boolean;
  login: (
    email: string,
    password: string,
    remember?: boolean
  ) => Promise<{ success: boolean; error?: string; handled?: boolean }>;
  register: (email: string, password: string, name: string) => Promise<boolean>;
  signOut: () => Promise<void>; // Changed return type to void
  refreshUser: () => Promise<User | null>;
  updatePassword: (newPassword: string) => Promise<boolean>;
  resetPassword: (email: string) => Promise<boolean>;
  setThemePreference: (themeId: string) => Promise<boolean>;
  fetchCurrentUser: () => Promise<User | null>;
  logout: () => Promise<void>; // Changed return type to void
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  setUser: () => {},
  isLoading: false,
  error: null,
  session: null,
  authInitialized: false,
  login: async () => ({ success: false }),
  register: async () => false,
  signOut: async () => {},
  refreshUser: async () => null,
  updatePassword: async () => false,
  resetPassword: async () => false,
  setThemePreference: async () => false,
  fetchCurrentUser: async () => null,
  logout: async () => {}
});

export const useAuth = () => useContext(AuthContext);
